import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CtaWithIcon from '../CtaWithIcon';

const Icon = styled.span`
    height: 30px;
    width: 30px;
    background: url(${'/assets/back_arrow.svg'}) no-repeat;
    background-position: center;
`;

const StyledCtaWithIcon = styled(CtaWithIcon)`
    &:hover, &:active {
        ${Icon} {
            background: url(${'/assets/leftArrow.svg'}) no-repeat;
        }
    }
`;

const BACK = 'Back';

const BackBtn = React.forwardRef((props, ref) => {
    return <StyledCtaWithIcon ref={ref} icon={<Icon />} {...props} />;
});

BackBtn.propTypes = {
    text: PropTypes.string,
};

BackBtn.defaultProps = {
    text: BACK,
};

export default BackBtn;
